export const COPY_MODE = '@/COPY_MODE';
export const AUTOFILL_MODE = '@/AUTOFILL_MODE';
export const COPY_EXCEL_MODE = '@/COPY_EXCEL_MODE';

export const AUTOFILL_SETTING_LOOP = '@/AUTOFILL_SETTING_LOOP';
export const AUTOFILL_SETTING_REPEAT = '@/AUTOFILL_SETTING_REPEAT';

export const SET_AUTOFILL_MODE = '@/SET_AUTOFILL_MODE';
export const SET_AUTOFILL_PATTERN = '@/SET_AUTOFILL_PATTERN';

export const SET_AUTOFILL_START = '@/SET_AUTOFILL_START';
export const SET_AUTOFILL_END = '@/SET_AUTOFILL_END';
export const SET_AUTOFILL_STEPS = '@/SET_AUTOFILL_STEPS';
export const SET_AUTOFILL_PREFIX = '@/SET_AUTOFILL_PREFIX';
export const SET_AUTOFILL_SUFFIX = '@/SET_AUTOFILL_SUFFIX';

export const SET_AUTOFILL_SETTING = '@/SET_AUTOFILL_SETTING';
export const SET_AUTOFILL_LOOPS_AMOUNT = '@/SET_AUTOFILL_LOOPS_AMOUNT';
export const SET_AUTOFILL_REPEATS_AMOUNT = '@/SET_AUTOFILL_REPEAT_NUMBER';

export const SET_AUTOFILL_COPIES_NO = '@/SET_AUTOFILL_COPIES_NO';
export const SET_AUTOFILL_PATTERN_SELECT_AVAILABLE_STATE =
  '@/SET_AUTOFILL_PATTERN_SELECT_AVAILABLE_STATE';
export const SET_AUTOFILL_MATRIX_TEMPLATE = '@/SET_AUTOFILL_MATRIX_TEMPLATE';
